import { Api } from '../api';
import type { IPage, CreateCustomerResp, IBusiness, ICustomer, IDeposit } from '../types';
import type { CustomerProduct } from '../types/customerProduct.type';

export class CustomerApi extends Api {

  public static async create(data: {
    name: string;
    docNumber?: string;
    phone?: string;
    email?: string;
    businessName: string;
    businessRnc?: string;
    businessPhone?: string;
    businessEmail?: string;
    businessCity: string;
    businessAddress: string;
    system: IBusiness['system'];
  }) {
    return this.post<CreateCustomerResp>('/admin/customers', data);
  }

  public static async update(
    customerId: number,
    data: {
      businessId: number;
      name?: string;
      docNumber?: string;
      phone?: string;
      email?: string;
      businessName?: string;
      businessRnc?: string;
      businessPhone?: string;
      businessEmail?: string;
      businessCity?: string;
      businessAddress?: string;
      system?: IBusiness['system'];
      status?: ICustomer['status'];
      isDistributor?: boolean;
    }
  ) {
    return this.patch<{ customer: ICustomer, business: IBusiness }>(`/admin/customers/${customerId}`, data);
  }

  public static async addProduct(
    customerId: number, 
    data: {
      profit: number;
      productId: number;
    }
  ) {
    return this.post<CustomerProduct>(`/admin/customers/${customerId}/products`, data);
  }

  public static async updateProduct(
    customerId: number,
    customerProductId: number,
    data: { 
      profit: number,
      productId: number
    }
  ) {
    return this.patch<CustomerProduct>(`/admin/customers/${customerId}/products/${customerProductId}`, data);
  }

  public static async getProducts(customerId: number) {
    return this.get<CustomerProduct[]>(`/admin/customers/${customerId}/products`);
  }

  public static async updateUsernameAndPassword(customerId: number, username: string, password: string) {
    return this.patch(`/admin/customers/${customerId}/update-username-and-password`, { username, password });
  }

  public static async getBalance(customerId: number) {
    return this.get<{ amount: number }>(`/admin/customers/${customerId}/balance`);
  }

  public static async getDeposits(customerId: number, page?: number, size?: number) {
    return this.get<IPage<IDeposit>>(`/admin/customers/${customerId}/deposits`, { 
      params: {
        page,
        size
      }
    });
  }

  public static async registerDeposit(
    customerId: number, 
    deposit: { 
      balance: number, 
      bankAccountId: number 
      date: Date,
      reference?: string, 
      description?: string, 
    }
  ) {
    return this.post(`/admin/customers/${customerId}/register-deposit`, deposit);
  }
}
